<template>
  <div class="home">
    <p>The Home Depot is on a mission to identify and<br /><strong>stop Organized Retail Crime in its tracks.</strong></p>
    <div class="form">
      <InputComponent />
      <NextButton @click.native="saveName" />
    </div>
    <p class="error" v-if="errors.length">
      <span v-for="error in errors" :key="error">{{ error }}</span>
    </p>
    <OrientationMessage v-if="showOrientationMessage" />
  </div>
</template>

<script>
import InputComponent from '@/components/InputComponent.vue'
import NextButton from '@/components/NextButton.vue'
import OrientationMessage from '@/components/OrientationMessage.vue'

export default {
  name: 'home',
  components: {
    InputComponent,
    NextButton,
    OrientationMessage
  },
  data() {
    return {
      showOrientationMessage: false,
      errors: []
    }
  },
  methods: {
    saveName: function() {  
      const name = this.$children[0].$el.value

      if (name.length) {
        this.$store.dispatch('addName', { name: name })
        this.errors = [];
        return this.$router.push('/intro');
      }

      this.errors = [];

      if (!name) {
        this.errors.push('Name required.');
      }
    }
  },
  mounted() {
    if(window.innerHeight > window.innerWidth) {
      this.showOrientationMessage = true
    }
    
    window.addEventListener('orientationchange', () => {
      if(window.innerHeight > window.innerWidth) {
        this.showOrientationMessage = false
        window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
      } else {
        this.showOrientationMessage = true
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', () => {})
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: url('~@/assets/login-bg.jpg') center center no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .error {
    margin-top: 5px;
    font-size: 18px;
    color: #F98B02;
  }

  .form {
    display: inline-block;
    position: relative;
  }

  p {
    color: #fff;
    font-size: 22px;
    line-height: 26px;
    margin-top: 198px;
  }

  .next-button {
    bottom: 4px;
    position: absolute;
    right: 5px;
    width: 47px;
  }
}
</style>
